import React, { useEffect, useState } from 'react';
import './Styles/main.css';

// Views
import LoginView from './Components/LoginView';
import MainView from './Components/MainView';

// Constants
import { SPLASH, MAIN, LOGIN } from './Constant/constants';

// Firebase
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Splash from './Components/Splash';

const App = () => {
  const firebaseConfig = {
    apiKey: "AIzaSyD3_GwfjcddoAeBODKDNSfIvlWp8sKQKJE",
    authDomain: "quinek.firebaseapp.com",
    projectId: "quinek-d86f3",
    storageBucket: "quinek-d86f3.appspot.com",
    messagingSenderId: "49551327666",
    appId: "1:49551327666:web:eafb39abe7e7e032ac64ab"
  };
  
  const [accessLevel, setAccess] = useState(SPLASH);
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const eDB = getFirestore(app);
  const storage = getStorage();
  
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if(user){
        user.getIdTokenResult()
        .then((idTokenResult) => {
            // Confirm the user is an Admin.
            if (!!idTokenResult.claims.admin) {
              setAccess(MAIN);
            } else {
              console.log("Error: User Not Allowed Here.");
            }
        })
        .catch((error) => {
            console.log(error);
        });
      }else{
        setAccess(LOGIN);
      }
    });
  },[]);

  switch(accessLevel){
    case LOGIN:
      return <LoginView auth={auth}/>;
    case MAIN:
      return <MainView auth={auth} eDB={eDB} storage={storage} />;
    default:
      return <Splash />;
  }
}

export default App;
